import React from 'react';
export var ReactReduxContext = /*#__PURE__*/React.createContext(null);
export default ReactReduxContext;